import { render, staticRenderFns } from "./HomeTab_new.vue?vue&type=template&id=2e8635ca&scoped=true&"
import script from "./HomeTab_new.vue?vue&type=script&lang=js&"
export * from "./HomeTab_new.vue?vue&type=script&lang=js&"
import style0 from "./HomeTab_new.vue?vue&type=style&index=0&id=2e8635ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8635ca",
  null
  
)

export default component.exports